<div class="register-container">

  <!-- LEFT: HERO SECTION -->
  <div class="hero-section">
    <div class="hero-content">
      <div class="brand-logo">
        <mat-icon>school</mat-icon> KSolve
      </div>
      <h1>Start Your Learning Journey</h1>
      <p>Create your free account to unlock interactive courses, track your progress, and access curated study materials.</p>

      <div class="hero-benefits">
        <div class="benefit-item">
          <mat-icon class="benefit-icon">bolt</mat-icon>
          <div>
            <strong>Instant Setup</strong>
            <p>Only basic information needed to get started in seconds.</p>
          </div>
        </div>
        <div class="benefit-item">
          <mat-icon class="benefit-icon">menu_book</mat-icon>
          <div>
            <strong>Interactive Curriculum</strong>
            <p>Explore Middle School Math, Science, and more courses.</p>
          </div>
        </div>
        <div class="benefit-item">
          <mat-icon class="benefit-icon">manage_accounts</mat-icon>
          <div>
            <strong>Flexible Profile</strong>
            <p>Add phone numbers and address details anytime from My Account.</p>
          </div>
        </div>
      </div>
    </div>
    <div class="hero-overlay"></div>
  </div>

  <!-- RIGHT: FORM SECTION -->
  <div class="form-section">
    <div class="form-wrapper">

      <div class="form-header">
        <h2>Create Account</h2>
        <p class="text-muted">Fill in your basic details below</p>
      </div>

      <!-- Quick Signup Callout -->
      <div class="quick-signup-notice">
        <mat-icon>sparkles</mat-icon>
        <span><strong>Quick Signup:</strong> Only name, email, and password required. You can add more details later in your profile.</span>
      </div>

      <form [formGroup]="registerForm" (ngSubmit)="registerUser()">

        <!-- Name Row -->
        <div class="row">
          <div class="col-md-6 mb-2">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>First Name</mat-label>
              <input matInput formControlName="firstName" placeholder="Jane" required>
              <mat-icon matSuffix>person</mat-icon>
              <mat-error *ngIf="f['firstName'].hasError('required')">First name is required</mat-error>
            </mat-form-field>
          </div>

          <div class="col-md-6 mb-2">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Last Name</mat-label>
              <input matInput formControlName="lastName" placeholder="Doe" required>
              <mat-icon matSuffix>person_outline</mat-icon>
              <mat-error *ngIf="f['lastName'].hasError('required')">Last name is required</mat-error>
            </mat-form-field>
          </div>
        </div>

        <!-- Email Address -->
        <div class="mb-2">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Email Address</mat-label>
            <input matInput formControlName="email" type="email" placeholder="jane.doe@example.com" required>
            <mat-icon matSuffix>email</mat-icon>
            <mat-error *ngIf="f['email'].hasError('required')">Email is required</mat-error>
            <mat-error *ngIf="f['email'].hasError('email')">Please enter a valid email address</mat-error>
          </mat-form-field>
        </div>

        <!-- Password Row -->
        <div class="row">
          <div class="col-md-6 mb-2">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Password</mat-label>
              <input matInput [type]="hidePassword ? 'password' : 'text'" formControlName="password" required>
              <button mat-icon-button matSuffix (click)="hidePassword = !hidePassword" type="button" tabindex="-1">
                <mat-icon>{{hidePassword ? 'visibility_off' : 'visibility'}}</mat-icon>
              </button>
              <mat-error *ngIf="f['password'].hasError('required')">Password is required</mat-error>
              <mat-error *ngIf="f['password'].hasError('minlength')">Min 8 characters</mat-error>
            </mat-form-field>
          </div>

          <div class="col-md-6 mb-2">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Confirm Password</mat-label>
              <input matInput [type]="hideConfirmPassword ? 'password' : 'text'" formControlName="confirmPassword" required>
              <button mat-icon-button matSuffix (click)="hideConfirmPassword = !hideConfirmPassword" type="button" tabindex="-1">
                <mat-icon>{{hideConfirmPassword ? 'visibility_off' : 'visibility'}}</mat-icon>
              </button>
              <mat-error *ngIf="f['confirmPassword'].hasError('required')">Confirm password is required</mat-error>
            </mat-form-field>
          </div>
        </div>

        <!-- Password Mismatch Alert -->
        <div *ngIf="registerForm.errors?.['passwordMismatch'] && (registerForm.touched || registerForm.dirty)" class="password-mismatch-error">
          <mat-icon>error_outline</mat-icon>
          <span>Passwords do not match</span>
        </div>

        <!-- Terms Notice -->
        <div class="terms-notice mt-2 mb-3">
          <p class="text-muted small">
            By creating an account, you agree to KSolve's 
            <a [href]="termsUrl" target="_blank" class="legal-link">Terms of Service</a> &amp; 
            <a [href]="privacyUrl" target="_blank" class="legal-link">Privacy Policy</a>.
          </p>
        </div>

        <!-- Action Button -->
        <div class="buttons">
          <button mat-flat-button color="primary" class="btn-register w-100" type="submit" [disabled]="isLoading">
            <mat-spinner diameter="20" *ngIf="isLoading" class="spinner-inline"></mat-spinner>
            <span *ngIf="!isLoading">Create Free Account</span>
            <span *ngIf="isLoading">Creating Account...</span>
          </button>
        </div>

        <!-- Login Link -->
        <div class="login-prompt text-center mt-4">
          <p>Already have an account? <a (click)="goToLogin()" class="signin-link">Sign In</a></p>
        </div>

      </form>
    </div>
  </div>

</div>